export default "__VITE_ASSET__2e7a29f3__"